module.exports = __webpack_public_path__ + "img/24_54.10685c19.png";